import { iRequest } from '@/utils/requestutil';

export async function save(payload) {
  return iRequest(
    `/iwms-openapi/api/articleItemProcessingConfig?companyUuid=${payload.companyUuid}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
    {
      method: 'POST',
      body: payload.fields,
    },
  );
}

export async function get(payload) {
  return iRequest(
    `/iwms-openapi/api/articleItemProcessingConfig/get?companyUuid=${payload.companyUuid}&interfaceConfigUuid=${payload.interfaceConfigUuid}`,
  );
}
